import { render } from "./Confirm.vue?vue&type=template&id=543ee2b0"
import script from "./Confirm.vue?vue&type=script&lang=js"
export * from "./Confirm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__